<template>
    <div class="floating-label-container">
        <label class="floating-label" :class="{ 'has-value': startDateValue }">
            {{ tra.start_date }}
        </label>
        <DatePicker 
            v-model="startDateValue" 
            name="start_date" 
            :disabledDays="[0, 2, 3, 4, 5, 6]" 
            :disabledDates="disabledVacationDates"
            :invalid="!startDateValue" 
            :minDate="new Date()"
            :showIcon="true" 
            iconDisplay="input"
            icon="pi pi-calendar" 
            size="small" 
            dateFormat="dd-mm-yy" 
            class="w-100" 
        />
    </div>
</template>

<script>
import DatePicker from 'primevue/datepicker';

export default {
    components: {
        DatePicker,
    },
    props: ['tra', 'disabledVacationDates'],
    data() {
        return {
            startDateValue: new Date(new Date().setDate(new Date().getDate() + 7 + (1 + 7 - new Date().getDay()) % 7)),
        };
    },
};
</script>

<style scoped>


/* Override PrimeVue DatePicker styles to remove default placeholder */
:deep(.p-datepicker-input) {
    padding-top: 8px !important;
}

:deep(.p-datepicker-input::placeholder) {
    opacity: 0;
}
</style>